import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  icon?: boolean;
}
export function CTAButton({
  children,
  onClick,
  variant = 'primary',
  icon = true
}: CTAButtonProps) {
  return <div className="px-6 py-6" data-id="element-12">
      <button onClick={onClick} className={`w-full py-4 px-6 rounded-lg font-bold text-base flex items-center justify-center gap-2 transition-smooth active:scale-[0.98] ${variant === 'primary' ? 'bg-roche-blue text-white active:bg-roche-blue-dark' : 'bg-white text-roche-blue border-2 border-roche-blue active:bg-gray-50'}`} data-id="element-13">
        <span data-id="element-14">{children}</span>
        {icon && <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-15" />}
      </button>
    </div>;
}